import { Injectable } from '@angular/core';
import { AnnualReward, Response } from '@app/core/interfaces';
import { RequestService } from '@app/core/request/request.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class AnnualRewardService {

    constructor(
        private request: RequestService,
    ) { }

    public loadAnnualReward$(): Observable<AnnualReward> {
        return this.request.post('relatie-algemeen/opvragen/donatiepersoonlijkejaarbeloning-tokencodeenbedrag')
            .pipe(map((response: Response) => {
                if (response.messages && response.messages.length > 0) {
                    throw response.messages;
                }
                return response.data;
            }));
    }
}
